export default {
'light': () => (() => {}),
'dark': () => (() => {}),
'spacing': () => (() => {}),
'typography': () => (() => {}),
'light-future': () => { 
    console.warn('AUI does not provide "light-future" theme. Setting this theme will have no effect.');
    return () => {};
}, 
'dark-future': () => { 
    console.warn('AUI does not provide "dark-future" theme. Setting this theme will have no effect.');
    return () => {};
}, 
'shape': () => { 
    console.warn('AUI does not provide "shape" theme. Setting this theme will have no effect.');
    return () => {};
}, 
'motion': () => { 
    console.warn('AUI does not provide "motion" theme. Setting this theme will have no effect.');
    return () => {};
}, 
'legacy-light': () => { 
    console.warn('AUI does not provide "legacy-light" theme. Setting this theme will have no effect.');
    return () => {};
}, 
'legacy-dark': () => { 
    console.warn('AUI does not provide "legacy-dark" theme. Setting this theme will have no effect.');
    return () => {};
}, 
'typography-adg3': () => { 
    console.warn('AUI does not provide "typography-adg3" theme. Setting this theme will have no effect.');
    return () => {};
}, 
'typography-modernized': () => { 
    console.warn('AUI does not provide "typography-modernized" theme. Setting this theme will have no effect.');
    return () => {};
}, 
'typography-refreshed': () => { 
    console.warn('AUI does not provide "typography-refreshed" theme. Setting this theme will have no effect.');
    return () => {};
}, 
};